import React, { useState, useContext, useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { PageContext } from "../layout/Page"
import { useOnClickOutside } from "../../utility/hooks/useOnClickOutside"
import cx from "classnames"
import { getArticlesPath, getWhitepapersPath } from "../../prismic/utility/linkResolver"

import Arrow from '../../assets/icons/language-arrow.svg'

export const LanguageSelect = ({ negative = false, mobile = false, wide = false, className = "" }) => {
  const { lang, folder, country, page: { alternate } } = useContext(PageContext)
  const [isOpen, setOpen] = useState(false)
  const [languageSwitchUrls, setLanguageSwitchUrls] = useState({
    'it-it': '',
    'en-gb': '',
    'es-es': '',
    'fr-fr': '',
  })
  const [t] = useTranslation("generics")
  const width = wide ? '' : 'max-w-fit'
  const padding = wide ? 'py-1.5 px-2' : 'px-1 py-0.5'
  const bgColor = wide ? 'bg-midnight-20' : ''
  const flagSize = wide ? 'w-3 h-3' : 'w-2.5 h-2.5'
  const fontWeight = wide ? '' : 'font-medium'

  const ref = useRef()
  useOnClickOutside(ref, () => setOpen(false))

  function switchPage() {
    setOpen(false)
  }

  useEffect(() => {
    setLanguageSwitchUrls({
      'it-it': getLanguageSwitchUrl('it-it'),
      'en-gb': getLanguageSwitchUrl('en-gb'),
      'es-es': getLanguageSwitchUrl('es-es'),
      'fr-fr': getLanguageSwitchUrl('fr-fr'),
    })
  }, [])

  function getLanguageSwitchUrl(newFolder) {
    let url = ''
    if (alternate[newFolder]) {
      url = alternate[newFolder]
    } else {
      if (window.location.pathname.includes(getArticlesPath(folder))) {
        url = '/' + newFolder + '/' + getArticlesPath(newFolder)
      } else if (window.location.pathname.includes(getWhitepapersPath(folder))) {
        url = '/' + newFolder + '/' + getWhitepapersPath(newFolder)
      } else {
        url = '/' + folder
      }
    }

    return url.endsWith("/") ? url : (url + '/')
  }

  return <div ref={ref} className={`${className} ${width} ${bgColor} ${!wide ? "" : "border-2"} relative  border-midnight-50 h-fit select-none rounded cursor-pointer transitions-all`} >
    <div onClick={() => setOpen(!isOpen)} className={`flex items-center ${wide ? 'justify-between' : ''} ${padding}`}>
      <div className="flex items-center">
        <div className={`${flagSize} mr-[6px]`} style={{ background: `url('/images/dls_flags/${country}.svg') center/cover` }} />
        <div className={`mr-[4px] ${fontWeight} ${negative ? 'text-white' : 'text-midnight-10'}`}>
          {wide ? t(`countries.${lang}-${country}.full`) : t(`countries.${lang}-${country}.short`)}
        </div>
      </div>
      {wide && <div>
        <Arrow className={`transitions-all ${negative ? 'stroke-white' : 'stroke-midnight-10'} ${isOpen ? 'rotate-180' : 'rotate-0'}`} />
      </div>}
    </div>
    <div
      className={cx(`${padding} absolute border-2 h-fit rounded normal-case bg-white shadow z-[150] min-w-[calc(100%+4px)]`, {
        "block": isOpen,
        "hidden": !isOpen,
        "-right-[2px]": !mobile,
        "left-0": mobile,
      })}
      style={{
        top: "calc(100% + 6px)"
      }}>
      <a className="flex items-center gap-1 text-link-unstyled" href={languageSwitchUrls['it-it']} onClick={() => switchPage()}>
        <div className={`${flagSize}`} style={{ background: `url('/images/dls_flags/it.svg') center/cover` }} />
        <div className="text-body text-midnight-10">{wide ? t("countries.it-it.full") : t("countries.it-it.short")}</div>
      </a>
      <a className="flex items-center gap-1 text-link-unstyled mt-0.5" href={languageSwitchUrls['en-gb']} onClick={() => switchPage()} >
        <div className={`${flagSize}`} style={{ background: `url('/images/dls_flags/gb.svg') center/cover` }} />
        <div className="text-body text-midnight-10">{wide ? t("countries.en-gb.full") : t("countries.en-gb.short")}</div>
      </a>
      <a className="flex items-center gap-1 text-link-unstyled mt-0.5" href={languageSwitchUrls['es-es']} onClick={() => switchPage()} >
        <div className={`${flagSize}`} style={{ background: `url('/images/dls_flags/es.svg') center/cover` }} />
        <div className="text-body text-midnight-10">{wide ? t("countries.es-es.full") : t("countries.es-es.short")}</div>
      </a>
      <a className="flex items-center gap-1 text-link-unstyled mt-0.5" href={languageSwitchUrls['fr-fr']} onClick={() => switchPage()} >
        <div className={`${flagSize}`} style={{ background: `url('/images/dls_flags/fr.svg') center/cover` }} />
        <div className="text-body text-midnight-10">{wide ? t("countries.fr-fr.full") : t("countries.fr-fr.short")}</div>
      </a>
    </div>
  </div>
}